// @ts-nocheck
import { get, post, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * @typedef {Object} Pedido
 * @property {number} Id - ID Ãºnico do pedido
 * @property {number} IdCarga - ID da carga relacionada
 * @property {string} NumeroDoPedido - NÃºmero do pedido
 * @property {string} LocalPalletizacao - Local de palletizaÃ§Ã£o
 * @property {string} DataAgendamento - Data de agendamento
 * @property {string} DataIntegracao - Data de integraÃ§Ã£o
 * @property {string} NumeroDaCarga - NÃºmero da carga
 * @property {string} TipoDaOperacao - Tipo da operaÃ§Ã£o
 * @property {string} SituacaoCarga - SituaÃ§Ã£o da carga
 * @property {string} Origem - Origem
 * @property {string} Destino - Destino
 * @property {string} DataCriacao - Data de criaÃ§Ã£o
 * @property {string} DataModificacao - Data de modificaÃ§Ã£o
 * @property {number} UsuarioCriacao - ID do usuÃ¡rio que criou
 * @property {number} UsuarioModificacao - ID do usuÃ¡rio que modificou
 */
/**
 * @typedef {Object} PedidoCreatePayload
 * @property {number} IdCarga - ID da carga relacionada
 * @property {string} NumeroDoPedido - NÃºmero do pedido
 * @property {string} [LocalPalletizacao] - Local de palletizaÃ§Ã£o
 * @property {string} [DataAgendamento] - Data de agendamento
 * @property {string} [DataIntegracao] - Data de integraÃ§Ã£o
 * @property {string} [Origem] - Origem
 * @property {string} [Destino] - Destino
 */
/**
 * @typedef {Object} PedidoFilters
 * @property {string} [NumeroDoPedido] - Filtro por nÃºmero do pedido
 * @property {number} [IdCarga] - Filtro por ID da carga
 * @property {string} [LocalPalletizacao] - Filtro por local de palletizaÃ§Ã£o
 * @property {string} [DataAgendamentoInicio] - Data de agendamento inicial
 * @property {string} [DataAgendamentoFim] - Data de agendamento final
 * @property {string} [DataIntegracaoInicio] - Data de integraÃ§Ã£o inicial
 * @property {string} [DataIntegracaoFim] - Data de integraÃ§Ã£o final
 * @property {number} [quantidadePorPagina] - Quantidade de registros por pÃ¡gina
 * @property {number} [pagina] - NÃºmero da pÃ¡gina
 */
/**
 * @typedef {Object} PedidosResponse
 * @property {Pedido[]} registros - Lista de pedidos
 * @property {number} totalRegistros - Total de registros encontrados
 * @property {number} paginaAtual - PÃ¡gina atual
 * @property {number} quantidadePorPagina - Quantidade de registros por pÃ¡gina
 */
/**
 * Lista pedidos com filtros e paginaÃ§Ã£o
 * @param {PedidoFilters} filters - Filtros para a busca
 * @returns {Promise<PedidosResponse>} Resposta com lista de pedidos
 */
export const getPedidos = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    // Adicionar filtros apenas se tiverem valor
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/pedidos?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca um pedido especÃ­fico por ID
 * @param {number} id - ID do pedido
 * @returns {Promise<Pedido>} Dados do pedido
 */
export const getPedidoById = async (id) => {
    const response = await get(`${API_URL}/pedidos/${id}`);
    return response?.data || response;
};
/**
 * Busca um pedido especÃ­fico por ID (alias para getPedidoById)
 * @param {number} id - ID do pedido
 * @returns {Promise<Pedido>} Dados do pedido
 */
export const getPedido = async (id) => {
    const response = await get(`${API_URL}/pedidos/${id}`);
    return response?.data || response;
};
/**
 * Cria um novo pedido
 * @param {PedidoCreatePayload} payload - Dados do pedido a ser criado
 * @returns {Promise<Pedido>} Pedido criado
 */
export const createPedido = async (payload) => {
    const response = await post(`${API_URL}/pedidos`, payload);
    return response?.data || response;
};
// Cria pedido a partir do depot
export const createPedidoDepot = async (payload) => {
    const response = await post(`${API_URL}/depots/criar-pedido`, payload);
    return response?.data || response;
};
/**
 * Atualiza um pedido existente
 * @param {number} id - ID do pedido
 * @param {PedidoCreatePayload} payload - Dados atualizados do pedido
 * @returns {Promise<Pedido>} Pedido atualizado
 */
export const updatePedido = async (id, payload) => {
    const response = await put(`${API_URL}/pedidos/${id}`, payload);
    return response?.data || response;
};
/**
 * Exclui um pedido
 * @param {number} id - ID do pedido a ser excluÃ­do
 * @returns {Promise<void>}
 */
export const deletePedido = async (id) => {
    await deleteRequest(`${API_URL}/pedidos/${id}`);
};
/**
 * Busca pedidos por carga
 * @param {number} cargaId - ID da carga
 * @returns {Promise<Pedido[]>} Lista de pedidos da carga
 */
export const getPedidosByCarga = async (cargaId) => {
    const response = await get(`${API_URL}/pedidos/carga/${cargaId}`);
    return response?.data || response || [];
};
/**
 * Busca pedidos por local de palletizaÃ§Ã£o
 * @param {string} localPalletizacao - Local de palletizaÃ§Ã£o
 * @returns {Promise<Pedido[]>} Lista de pedidos do local
 */
export const getPedidosByLocalPalletizacao = async (localPalletizacao) => {
    const response = await get(`${API_URL}/pedidos/local-palletizacao/${encodeURIComponent(localPalletizacao)}`);
    return response?.data || response || [];
};
/**
 * Busca pedidos por perÃ­odo de agendamento
 * @param {string} dataInicio - Data inicial
 * @param {string} dataFim - Data final
 * @returns {Promise<Pedido[]>} Lista de pedidos do perÃ­odo
 */
export const getPedidosByPeriodoAgendamento = async (dataInicio, dataFim) => {
    const response = await get(`${API_URL}/pedidos/periodo-agendamento?inicio=${dataInicio}&fim=${dataFim}`);
    return response?.data || response || [];
};
/**
 * Busca pedidos por perÃ­odo de integraÃ§Ã£o
 * @param {string} dataInicio - Data inicial
 * @param {string} dataFim - Data final
 * @returns {Promise<Pedido[]>} Lista de pedidos do perÃ­odo
 */
export const getPedidosByPeriodoIntegracao = async (dataInicio, dataFim) => {
    const response = await get(`${API_URL}/pedidos/periodo-integracao?inicio=${dataInicio}&fim=${dataFim}`);
    return response?.data || response || [];
};
/**
 * ObtÃ©m estatÃ­sticas de pedidos
 * @returns {Promise<Object>} EstatÃ­sticas de pedidos
 */
export const getEstatisticasPedidos = async () => {
    const response = await get(`${API_URL}/pedidos/estatisticas`);
    return response?.data || response || {};
};
/**
 * Obtém recomendações de frota para um pedido específico
 * @param {number|string} idPedido - Identificador do pedido
 * @returns {Promise<any>} Objeto com pedido, modelos considerados e recomendações
 */
export const getRecomendacaoFrotaByPedido = async (idPedido) => {
    if (idPedido === null || idPedido === undefined || idPedido === '') {
        return {};
    }
    const url = `${API_URL}/veiculos/pedido/${idPedido}`;
    const response = await get(url);
    return response?.data || response || {};
};
